export type AddOrganizationModalState = {
  readonly show: boolean
  readonly submitting: boolean
}

export const ADD_ORGANIZATION_MODAL_STORE_ID = 'AddOrganizationModal'
